<template>
	<div class="flex size-full items-center">
		<div
			class="won-tag-light-gray absolute h-full"
			:style="{ 'width': rulerPaddings.leftPadding + 'px' }"
		/>
		<div
			class="won-tag-light-gray absolute right-0 h-full"
			:style="{ 'width': rulerPaddings.rightPadding + 'px' }"
		/>
    
		<div class="relative flex w-full flex-row select-none">
			<div
				v-for="k in 8"
				:id="`${k}_ruler`"
				:key="`${k}_ruler`"
				style="width: 12.5%"
				class="relative flex h-full flex-row items-center justify-between"
			>
				<div
					v-for="item in 8"
					:key="`${item}_subruler`"
					style="width: 12.5%"
					:class="{
						'h-[3px] border-r' : item < 8 && item !== 4,
						'h-[7px] border-r': item === 8 && item !== 4,
						'h-[3px] border-0': item === 4
					}"
					class="border-won-silver-cloud-gray"
				/>
				<div
					v-show="showNumbers"
					class="absolute inset-x-0 mx-auto w-max text-[10px] leading-[12px] text-won-blue"
					v-html="k"
				/>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useBuilderStyles } from '../../store/builder-style.store';

const builderStyle = useBuilderStyles();
const { zoom, getRullerPaddings: rulerPaddings  } = storeToRefs(builderStyle);
const showNumbers = ref(true);

watch(zoom, (newZoom) => {
	showNumbers.value = newZoom > 50;
});
</script>